import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TkadlecMemories from "./TkadlecMemories";
import "../TkadlecSnu/TkadlecSnu.css";

export default function TkadlecMemoriesPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash === "#routines") {
      navigate("/anna-core#routines", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="tkadlec-snu">
      <TkadlecMemories />
    </div>
  );
}